import React, { useState, useEffect } from "react";
import { Button, Img, MobileInput, Input, Text } from "components";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { YourDetails } from "popups/YourDetails";
import { getAuth } from "../../../../redux/reducers/loginData";
import globalRequest from "../../../../utils/global/globalRequest";
import * as CUSTOM from "../../../../utils/helper/custom";
import * as APIS from "../../../../utils/helper/Enum";
import { changeLoader } from "../../../../redux/reducers/loader";
import { setSnackbar } from "../../../../redux/reducers/snackbar";
import { changeTrigger } from "redux/reducers/trigger";
import {
  updateOrderData,
  getOrderData,
} from "../../../../redux/reducers/orderData";
import {
  addDeleteGetLocalStorage,
  checkoutStorageKeys,
  storageKeys,
} from "../../../../utils/global/localData";
import { useAppFont } from "utils/helper/useAppFont";


let defaultGuestId = CUSTOM.getDeviceID();
let defaultGuestData = {
  account_name: "Guest",
  first_name: "",
  last_name: "",
  mobile_no: "",
  // email: "",
  guest_id: defaultGuestId,
  isData: false,
};

// let defaultSignupData = {
//   first_name: "",
//   last_name: "",
//   mobile_no: "",
//   email: "",
//   otp: "",
//   email_otp: "",
// };

const Account = ({ addressList }) => {
  const { t } = useTranslation();
  const [YourDetailsOpen, setYourDetailsOpen] = useState(false);
  const auth = useSelector(getAuth);
  const [isLogin, setIsLogin] = useState(true);
  const [step, setStep] = useState(1); 
  const [timer, setTimer] = useState(0);
  const orderData = useSelector(getOrderData);
  const [guestDetail, setGuestDetail] = useState(defaultGuestData);
  const dispatch = useDispatch();
  const [isGuestMode, setIsGuestMode] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const { interClass, headingClass, interFamily, headingFamily } = useAppFont();
  
  const [formData, setFormData] = useState({
    mobile: "",
    firstName: "",
    lastName: "",
    otp: ""
  });
  const [errors, setErrors] = useState({});
  const [disableBtn, setDisableBtn] = useState(false);

  // const [formData, setFormData] = useState({
  //   login: {},
  //   signup: {},
  // });
  // const [errorformData, setErrorFormData] = useState({
  //   login: {
  //     is_verify_disable: true,
  //   },
  //   signup: {
  //     is_verify_disable: true,
  //   },
  // });

  /*
   * Check Login Form
   */
  // const checkLoginForm = () => {
  //   let disabledBtn = true;
  //   if (formData?.login?.is_otp_sent) {
  //     if (CUSTOM.isValidField(formData?.login?.otp, "otp")) {
  //       disabledBtn = false;
  //     }
  //   } else {
  //     if (CUSTOM.isValidField(formData?.login?.mobile_no, "mobile")) {
  //       disabledBtn = false;
  //     }
  //   }
  //   setErrorFormData({
  //     ...errorformData,
  //     login: { ...errorformData.login, is_verify_disable: disabledBtn },
  //   });
  // };

  /*
   * Check user for login/signup
   */
  const checkUser = async () => {
    let validationErrors = {};
    
    if (isLogin) {
      if (!formData.mobile) {
        validationErrors.mobile = t("mobileIsRequired");
      }
      let mobileValidation = CUSTOM.isValidMobile(formData.mobile, t);
      validationErrors = { ...validationErrors, ...mobileValidation };
    } else {
      if (!formData.firstName) {
        validationErrors.firstName = t("firstNameIsRequired");
      }
      if (!formData.lastName) {
        validationErrors.lastName = t("lastNameIsRequired");
      }
      if (!formData.mobile) {
        validationErrors.mobile = t("mobileIsRequired");
      }
      let mobileValidation = CUSTOM.isValidMobile(formData.mobile, t);
      validationErrors = { ...validationErrors, ...mobileValidation };
    }

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      dispatch(changeLoader(true));

      if (isLogin) {
        try {
          let response = await globalRequest(
            APIS?.ONBOARDING_APIS?.CHECK_USER_BY_MOBILE,
            "post",
            { mobile_no: formData.mobile.trim() }
          );
          response = response?.data;

          if (response?.status !== "SUCCESS") {
            setErrors({ mobile: response?.message });
            dispatch(changeLoader(false));
            return;
          }

          if (response?.data?.is_new_user == 1) {
            setErrors({ mobile: t("userNotFound") });
            dispatch(changeLoader(false));
            return;
          }

          await sendOtp();
        } catch (e) {
          dispatch(changeLoader(false));
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: e?.message,
              snackbarState: "error",
            })
          );
        }
      } else {
        try {
          let response = await globalRequest(
            APIS?.ONBOARDING_APIS?.CHECK_USER_BY_MOBILE,
            "post",
            { mobile_no: formData.mobile.trim() }
          );
          response = response?.data;

          if (response?.status !== "SUCCESS") {
            setErrors({ mobile: response?.message });
            dispatch(changeLoader(false));
            return;
          }

          if (response?.data?.is_new_user == 0) {
            setErrors({ mobile: t("mobileAlreadyRegistered") });
            setIsLogin(true);
            dispatch(changeLoader(false));
            return;
          }

          let input_data = {
            type: "email_and_mobile",
            mobile_no: formData.mobile,
            email: "",
            first_name: formData.firstName,
            last_name: formData.lastName
          };

          let otpResponse = await globalRequest(
            APIS?.ONBOARDING_APIS?.SEND_OTP,
            "post",
            input_data
          );
          otpResponse = otpResponse?.data;
          dispatch(changeLoader(false));

          if (otpResponse?.status !== "SUCCESS") {
            dispatch(
              setSnackbar({
                snackbarOpen: true,
                snackbarMessage: otpResponse?.message,
                snackbarState: "error",
              })
            );
            return;
          }

          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: otpResponse?.message,
              snackbarState: "success",
            })
          );

          setStep(2);
          setTimer(process.env.REACT_APP_OTP_TIMER || 30);
          setFormData({ ...formData, otp: "" });
        } catch (e) {
          dispatch(changeLoader(false));
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: e?.message,
              snackbarState: "error",
            })
          );
        }
      }
    }
  };

  /*
   * Send OTP
   */
  const sendOtp = async () => {
    if (timer !== 0) {
      return;
    }

    setErrors({});
    dispatch(changeLoader(true));

    try {
      let input_data = {
        mobile_no: formData.mobile,
        type: "mobile",
        first_name: formData.firstName,
        last_name: formData.lastName,
      };

      let response = await globalRequest(
        APIS?.ONBOARDING_APIS?.SEND_OTP,
        "post",
        input_data
      );
      response = response?.data;
      dispatch(changeLoader(false));

      if (response?.status !== "SUCCESS") {
        setErrors({ otp: response?.message });
        return;
      }

      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: response?.message,
          snackbarState: "success",
        })
      );

      setStep(2);
      setTimer(process.env.REACT_APP_OTP_TIMER || 30);
      setFormData({ ...formData, otp: "" });
    } catch (e) {
      dispatch(changeLoader(false));
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
  };

  /*
   * Verify OTP and Login/Signup
   */
  const verifyOtp = async () => {
    if (!formData.otp || formData.otp.length !== 4) {
      setErrors({ otp: t("pleaseEnterValidOtp") });
      return;
    }

    dispatch(changeLoader(true));

    try {
      let input_data = {
        mobile_no: formData.mobile,
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: "",
        otp: formData.otp,
        device_id: CUSTOM.getDeviceID(),
      };

      let response = await globalRequest(
        isLogin ? APIS?.ONBOARDING_APIS?.LOGIN_WITH_OTP : APIS?.ONBOARDING_APIS?.SIGNUP,
        "post",
        input_data
      );

      response = response?.data;
      dispatch(changeLoader(false));

      if (response?.status !== "SUCCESS") {
        setErrors({ otp: response?.message });
        return;
      }
      addDeleteGetLocalStorage(
        checkoutStorageKeys.ACCOUNT_DETAILS,
        {
          first_name: response?.data?.first_name,
          last_name: response?.data?.last_name,
          mobile_no: formData.mobile,
          email: response?.data?.email || "",
          isAuth: true,
        },
        "add",
        "single"
      );

      // Save token
      addDeleteGetLocalStorage(
        storageKeys?.USER_TOKEN,
        response?.data?.token,
        "add",
        "single"
      );

      // Reset form
      cancelForm();
      
      // Trigger login event
      dispatch(changeTrigger("loggedin"));
    } catch (e) {
      dispatch(changeLoader(false));
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
  };

  // /*
  //  *Login By mobile number
  //  */
  // const login = async () => {
  //   try {
  //     let response = await globalRequest(
  //       APIS?.ONBOARDING_APIS?.LOGIN_WITH_OTP,
  //       "post",
  //       { ...formData?.login, device_id: CUSTOM.getDeviceID() }
  //     );
  //     response = response?.data;
  //     if (response?.status !== "SUCCESS") {
  //       setErrorFormData({
  //         ...errorformData,
  //         login: { ...errorformData.login, otp: response?.message },
  //       });
  //       return;
  //     }
  //     cancelForm("login");
  //     addDeleteGetLocalStorage(
  //       storageKeys?.USER_TOKEN,
  //       response?.data?.token,
  //       "add",
  //       "single"
  //     );
  //     dispatch(changeTrigger("loggedin"));
  //   } catch (e) {
  //     dispatch(
  //       setSnackbar({
  //         snackbarOpen: true,
  //         snackbarMessage: e?.message,
  //         snackbarState: "error",
  //       })
  //     );
  //   }
  //   dispatch(changeLoader(false));
  // };

  /*
   * get guest details
   */
  const getGuestDetails = async () => {
    try {
      let response = await globalRequest(
        APIS?.GUEST?.GET_DETAILS,
        "get",
        {},
        {
          params: { guest_id: CUSTOM.getDeviceID() ? CUSTOM.getDeviceID() : 0 },
        }
      );
      response = response?.data;
      dispatch(changeLoader(false));
      if (response?.status == "SUCCESS") {
        let responseData = {
          account_name: "Guest",
          first_name: response?.data?.firstName,
          last_name: response?.data?.lastName,
          mobile_no: CUSTOM.getMobileNo(response?.data?.mobileNo, "No"),
          // email: response?.data?.email,
          guest_id: CUSTOM.getDeviceID(),
          isData: true,
        };
        setGuestDetail(responseData);
        // dispatch(
        //   updateOrderData({
        //     pageStep: 2,
        //     userDetails: responseData,
        //     accountForm: "completed",
        //   })
        // );
      } else {
      }
    } catch (e) {}
  };

  const saveGuestAndProceed = async () => {
    let validationErrors = {};
    
    if (!guestDetail.first_name) {
      validationErrors.firstName = t("firstNameIsRequired");
    }
    if (!guestDetail.last_name) {
      validationErrors.lastName = t("lastNameIsRequired");
    }
    if (!guestDetail.mobile_no) {
      validationErrors.mobile = t("mobileIsRequired");
    }
    
    let mobileValidation = CUSTOM.isValidMobile(guestDetail.mobile_no, t);
    validationErrors = { ...validationErrors, ...mobileValidation };

    if (!agreeTerms) {
      validationErrors.terms = t("pleaseAgreeToTerms");
    }

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      dispatch(changeLoader(true));
      try {
        let response = await globalRequest(
          APIS?.GUEST?.ADD_GUEST,
          "post",
          guestDetail
        );
        response = response?.data;
        dispatch(changeLoader(false));
        
        if (response?.status == "SUCCESS") {
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: response?.message,
              snackbarState: "success",
            })
          );
          
          dispatch(
            updateOrderData({
              pageStep: 2,
              userDetails: guestDetail,
              accountForm: "completed",
            })
          );
          
          addDeleteGetLocalStorage(
            checkoutStorageKeys.ACCOUNT_DETAILS,
            {
              ...guestDetail,
              isAuth: false,
            },
            "add",
            "single"
          );

        } else {
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: response?.message,
              snackbarState: "error",
            })
          );
        }
      } catch (e) {
        dispatch(changeLoader(false));
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: e?.message,
            snackbarState: "error",
          })
        );
      }
    }
  };

  // /*
  //  * save guest details
  //  */
  // const saveGuest = async (data = "", type = "") => {
  //   let moobileNo = type == "popup" ? data?.mobile_no : guestDetail?.mobile_no;
  //   let validateMobile = CUSTOM.isValidMobile(moobileNo, t);
  //   if (Object.keys(validateMobile).length > 0) {
  //     setErrorFormData({
  //       ...errorformData,
  //       login: {
  //         ...errorformData.login,
  //         ...validateMobile,
  //       },
  //     });
  //     return;
  //   }
  //   try {
  //     let payloadData = type == "popup" ? data : guestDetail;
  //     let response = await globalRequest(
  //       APIS?.GUEST?.ADD_GUEST,
  //       "post",
  //       payloadData
  //     );
  //     response = response?.data;
  //     dispatch(changeLoader(false));
  //     if (response?.status == "SUCCESS") {
  //       dispatch(
  //         setSnackbar({
  //           snackbarOpen: true,
  //           snackbarMessage: response?.message,
  //           snackbarState: "success",
  //         })
  //       );
  //       // dispatch(
  //       //   updateOrderData({
  //       //     pageStep: 2,
  //       //     userDetails: guestDetail,
  //       //     accountForm: "completed",
  //       //   })
  //       // );
  //       getGuestDetails();
  //       return true;
  //     } else {
  //       dispatch(
  //         setSnackbar({
  //           snackbarOpen: true,
  //           snackbarMessage: response?.message,
  //           snackbarState: "error",
  //         })
  //       );
  //     }
  //   } catch (e) {
  //     dispatch(
  //       setSnackbar({
  //         snackbarOpen: true,
  //         snackbarMessage: e?.message,
  //         snackbarState: "error",
  //       })
  //     );
  //   }
  // };

  // /*
  //  *validation form
  //  */
  // const validateForm = (data, type = "login") => {
  //   let errors = {};
  //   switch (type) {
  //     case "guest":
  //       if (data?.mobile_no) {
  //         if (data?.mobile_no.length != 9) {
  //           errors.mobile_no = t("mobile_no_length_error");
  //         }
  //       } else {
  //         errors.mobile_no = t("mobile_no_required");
  //       }
  //       if (!data?.first_name) {
  //         errors.first_name = t("first_name_required");
  //       }
  //       if (data?.email) {
  //         if (!CUSTOM.isValidField(data?.email, "email")) {
  //           errors.email = t("email_name_required");
  //         }
  //       } 
  //       // else {
  //       //   errors.email = t("email_name_required");
  //       // }
  //       if (!data?.last_name) {
  //         errors.last_name = t("last_name_required");
  //       }
  //       break;

  //     case "signup":
  //       if (data?.mobile_no) {
  //         if (data?.mobile_no.length != 9) {
  //           errors.mobile_no = t("mobile_no_length_error");
  //         }
  //       } else {
  //         errors.mobile_no = t("mobile_no_required");
  //       }
  //       if (!data?.first_name) {
  //         errors.first_name = t("first_name_required");
  //       }
  //       // if (data?.email) {
  //       //   const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  //       //   if (!emailRegex.test(data?.email)) {
  //       //     errors.email = t("email_name_required");
  //       //   }
  //       // } 
  //       // else {
  //       //   errors.email = t("email_name_required");
  //       // }
  //       if (!data?.last_name) {
  //         errors.last_name = t("last_name_required");
  //       }
  //       break;

  //     default:
  //       break;
  //   }

  //   return errors;
  // };

  /*
   *cancel form
   */
  const cancelForm = () => {
    setFormData({
      mobile: "",
      firstName: "",
      lastName: "",
      otp: ""
    });
    setErrors({});
    setStep(1);
    setTimer(0);
    setIsLogin(true);
    setIsGuestMode(false);
    setAgreeTerms(false);
  };

  // /**
  //  * otp send for signup option
  //  */
  // const sendSignupOtp = async () => {
  //   let validateMobile = CUSTOM.isValidMobile(formData?.signup?.mobile_no, t);
  //   if (Object.keys(validateMobile).length > 0) {
  //     setErrorFormData({
  //       ...errorformData,
  //       signup: {
  //         ...errorformData.signup,
  //         ...validateMobile,
  //       },
  //     });
  //     return;
  //   }
  //   try {
  //     dispatch(changeLoader(true));
  //     let response = await globalRequest(
  //       APIS?.CART?.CART_SIGNUP_SEND_OTP,
  //       "post",
  //       formData?.signup
  //     );
  //     response = response?.data;
  //     if (response.status != "SUCCESS") {
  //       dispatch(
  //         setSnackbar({
  //           snackbarOpen: true,
  //           snackbarMessage: response?.message,
  //           snackbarState: "error",
  //         })
  //       );
  //     } else {
  //       dispatch(
  //         setSnackbar({
  //           snackbarOpen: true,
  //           snackbarMessage: response?.message,
  //           snackbarState: "success",
  //         })
  //       );
  //       setFormData({
  //         formData,
  //         signup: { ...formData.signup, is_otp_sent: true, otp: "" },
  //       });
  //       setTimer(process.env.REACT_APP_OTP_TIMER);
  //     }
  //   } catch (e) {
  //     dispatch(
  //       setSnackbar({
  //         snackbarOpen: true,
  //         snackbarMessage: e?.message,
  //         snackbarState: "error",
  //       })
  //     );
  //   }
  //   dispatch(changeLoader(false));
  // };

  // /**
  //  * resend otp
  //  */
  // const sendOtp = async (type = "mobile") => {
  //   let validateMobile = CUSTOM.isValidMobile(formData?.signup?.mobile_no, t);
  //   if (Object.keys(validateMobile).length > 0) {
  //     setErrorFormData({
  //       ...errorformData,
  //       signup: {
  //         ...errorformData.signup,
  //         ...validateMobile,
  //       },
  //     });
  //     return;
  //   }
  //   let input_data = {
  //     mobile_no: formData?.signup?.mobile_no,
  //     email: formData?.signup?.email,
  //     type: type,
  //     first_name: formData?.signup?.first_name,
  //     last_name: formData?.signup?.last_name,
  //   };
  //   try {
  //     dispatch(changeLoader(true));
  //     let response = await globalRequest(
  //       APIS?.ONBOARDING_APIS?.SEND_OTP,
  //       "post",
  //       input_data
  //     );
  //     response = response?.data;
  //     if (response?.status == "SUCCESS") {
  //       dispatch(
  //         setSnackbar({
  //           snackbarOpen: true,
  //           snackbarMessage: response?.message,
  //           snackbarState: "success",
  //         })
  //       );
  //       if (type == "email") {
  //         setFormData({
  //           formData,
  //           signup: { ...formData.signup, is_otp_sent: true, emailOtp: "" },
  //         });
  //         setEmailTimer(process.env.REACT_APP_OTP_TIMER);
  //         setErrorFormData({
  //           ...errorformData,
  //           signup: { ...errorformData.signup, emailOtp: "" },
  //         });
  //       } else if (type == "mobile") {
  //         setFormData({
  //           formData,
  //           signup: { ...formData.signup, is_otp_sent: true, otp: "" },
  //         });
  //         setTimer(process.env.REACT_APP_OTP_TIMER);
  //         setErrorFormData({
  //           ...errorformData,
  //           signup: { ...errorformData.signup, otp: "" },
  //         });
  //       } else {
  //         setFormData({
  //           formData,
  //           signup: {
  //             ...formData.signup,
  //             is_otp_sent: true,
  //             otp: "",
  //             emailOtp: "",
  //           },
  //         });
  //         setTimer(process.env.REACT_APP_OTP_TIMER);
  //         setEmailTimer(process.env.REACT_APP_OTP_TIMER);
  //       }
  //     } else {
  //       dispatch(
  //         setSnackbar({
  //           snackbarOpen: true,
  //           snackbarMessage: response?.message,
  //           snackbarState: "error",
  //         })
  //       );
  //     }
  //   } catch (e) {
  //     dispatch(
  //       setSnackbar({
  //         snackbarOpen: true,
  //         snackbarMessage: e?.message,
  //         snackbarState: "error",
  //       })
  //     );
  //   }

  //   dispatch(changeLoader(false));
  // };

  // /**
  //  * user signup
  //  */
  // const registration = async () => {
  //   dispatch(changeLoader(true));
  //   try {
  //     let response = await globalRequest(
  //       APIS?.ONBOARDING_APIS?.SIGNUP,
  //       "post",
  //       { ...formData?.signup, device_id: CUSTOM.getDeviceID(), otp_email: formData?.signup?.emailOtp }
  //     );
  //     response = response?.data;
  //     if (response?.status !== "SUCCESS") {
  //       if (response?.data?.type == "mobile") {
  //         setErrorFormData({
  //           ...errorformData,
  //           signup: { otp: response?.message },
  //         });
  //       } else if (response?.data?.type == "email") {
  //         setErrorFormData({
  //           ...errorformData,
  //           signup: { emailOtp: response?.message },
  //         });
  //       } else {
  //         dispatch(
  //           setSnackbar({
  //             snackbarOpen: true,
  //             snackbarMessage: response?.message,
  //             snackbarState: "error",
  //           })
  //         );
  //       }
  //       dispatch(changeLoader(false));
  //       return;
  //     }
  //     addDeleteGetLocalStorage(
  //       storageKeys?.USER_TOKEN,
  //       response?.data?.token,
  //       "add",
  //       "single"
  //     );
  //     cancelForm("signup");
  //     dispatch(changeTrigger("loggedin"));
  //   } catch (e) {
  //     dispatch(
  //       setSnackbar({
  //         snackbarOpen: true,
  //         snackbarMessage: e?.message,
  //         snackbarState: "error",
  //       })
  //     );
  //   }
  //   dispatch(changeLoader(false));
  // };

  useEffect(() => {
    if (!auth?.id) {
      if (orderData?.pageStep === 1) {
      }
      
      let obj = { ...orderData };
      let isPageTwoStepComplete = false;
      if (guestDetail?.isData || orderData?.userDetails?.first_name) {
        isPageTwoStepComplete = true;
        if (!obj.pageStep || obj.pageStep < 2) {
          obj.pageStep = 2;
        }
        obj.accountForm = "completed";
        if (guestDetail?.isData && !obj.userDetails?.first_name) {
          obj.userDetails = guestDetail;
        }
      }
      if (addressList.length > 0 && isPageTwoStepComplete && orderData?.pageStep !== 1) {
        if (
          !orderData?.DeliveryModeActiveTab ||
          orderData?.DeliveryModeActiveTab == 1
        ) {
          obj = {
            ...obj,
            DeliveryModeActiveTab: 1,
            delivery_mode: "home_office",
            delivery_type: "",
            deliveryDateTimeActiveTab: 0,
            pageStep: obj.pageStep >= 3 ? obj.pageStep : 3, // Keep current step if >= 3
            delivery_mode_show: "hide",
            home_office: {
              address: CUSTOM.buildFullAddress(addressList[0]),
              itemDetail: addressList[0],
            },
          };
        }
      }
      const hasChanges = 
        obj.accountForm !== orderData.accountForm ||
        obj.pageStep !== orderData.pageStep ||
        JSON.stringify(obj.userDetails) !== JSON.stringify(orderData.userDetails);
        
      if (hasChanges) {
        dispatch(updateOrderData(obj));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressList?.length, guestDetail?.isData]); // Only trigger on these specific changes

  useEffect(() => {
    if (
      auth?.id == 0 &&
      CUSTOM.getDeviceID() &&
      !orderData?.userDetails?.first_name
    ) {
      getGuestDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  useEffect(() => {
    const savedAccountDetails = addDeleteGetLocalStorage(
      checkoutStorageKeys.ACCOUNT_DETAILS,
      {},
      "get"
    );
    
    if (savedAccountDetails) {
      try {
        const accountData = JSON.parse(savedAccountDetails);
        
        if (accountData.isAuth && auth?.id !== 0) {
          return;
        }
        
        if (!accountData.isAuth && accountData.first_name && !orderData?.userDetails?.first_name) {
          const restoredGuestData = {
            account_name: "Guest",
            first_name: accountData.first_name,
            last_name: accountData.last_name,
            mobile_no: accountData.mobile_no,
            guest_id: accountData.guest_id || CUSTOM.getDeviceID(),
            isData: true,
          };
          
          setGuestDetail(restoredGuestData);
          dispatch(
            updateOrderData({
              ...orderData,
              userDetails: restoredGuestData,
              accountForm: "completed",
              pageStep: orderData?.pageStep > 1 ? orderData?.pageStep : 2,
            })
          );
        }
      } catch (e) {
        console.error("Error restoring account details:", e);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * check user login
   */
  useEffect(() => {
    if (auth?.id != 0 && !orderData?.userDetails?.first_name) {
      let newDataUser = {
        account_name: CUSTOM.replaceKeyValue(auth?.mobileNo, "-", " "),
        first_name: auth?.firstName,
        last_name: auth?.lastName,
        mobile_no: CUSTOM.getMobileNo(auth?.mobileNo, "number"),
        email: auth?.email,
        guest_id: defaultGuestId,
      };
      
      addDeleteGetLocalStorage(
        checkoutStorageKeys.ACCOUNT_DETAILS,
        {
          first_name: auth?.firstName,
          last_name: auth?.lastName,
          mobile_no: CUSTOM.getMobileNo(auth?.mobileNo, "number"),
          email: auth?.email,
          isAuth: true,
        },
        "add",
        "single"
      );

      dispatch(updateOrderData({
        ...orderData,
        userDetails: newDataUser,
        accountForm: "completed",
        pageStep: orderData?.pageStep ? orderData.pageStep : 2,
      }));
    }
    // eslint-disable-next-line
  }, [auth?.id]);

  /**
   * mobile Otp timer check
   */
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  // /**
  //  * email Otp timer check
  //  */
  // useEffect(() => {
  //   let interval;
  //   const countdown = () => {
  //     if (emailTimer > 0) {
  //       setEmailTimer((prevTimer) => prevTimer - 1);
  //     }
  //   };
  //   interval = setInterval(countdown, 1000);
  //   return () => clearInterval(interval);
  // }, [emailTimer]);

  /**
   * Button disable/enable based on form data
   */
  useEffect(() => {
    let status = false;

    if (isGuestMode) {
      status = !guestDetail.first_name || !guestDetail.last_name || !guestDetail.mobile_no || !agreeTerms;
    } else {
      if (step === 1) {
        if (isLogin) {
          status = !formData.mobile;
        } else {
          status = !formData.firstName || !formData.lastName || !formData.mobile;
        }
      } else if (step === 2) {
        status = !formData.otp || formData.otp.length !== 4;
      }
    }

    setDisableBtn(status);
  }, [formData, step, isLogin, isGuestMode, guestDetail, agreeTerms]);

  const showAccountSummary = orderData?.accountForm === "completed" && 
                            orderData?.userDetails && 
                            Object.keys(orderData.userDetails).length > 0;

  return (
    <>
      <div className="relative flex flex-col w-full">
        {/* After login/signup - Show Account Summary */}
        {showAccountSummary && (
          <>
            <div className="flex flex-col gap-4 items-center justify-start w-full mb-[18px]">
              <div className="flex flex-row md:gap-5 items-center justify-start w-full">
                <div className="flex flex-col gap-1 items-start justify-start flex-1">
                  <Text className={`relative z-10 break-words
                    text-[#1A1A1A] ${headingClass} font-medium
                    text-[24px] leading-[32px]
                    sm:text-[20px] sm:leading-[28px]
                  `}>
                    {/* {t("account")} */}
                    Account Information
                  </Text>
                  <div className="flex gap-1 flex-row items-center">
                    <Text className="text-black-900 text-sm nunitoregular">
                      {orderData?.userDetails?.account_name}
                    </Text>
                    <Img
                      className="h-6 w-6"
                      src="images/img_checkmark_teal_400.svg"
                      alt="checkmark"
                    />
                  </div>
                </div>
                {auth?.id == 0 && (
                  <Button
                    className="w-auto mx-auto px-3 py-1.5 text-sm"
                    size="sm"
                    variant="OutlineBlack"
                    hover={true}
                    hoverclass="bg-black-900"
                    onClick={(e) => {
                      setGuestDetail(orderData?.userDetails);
                      dispatch(
                        updateOrderData({
                          ...orderData,
                          accountForm: "",
                          pageStep: 1,
                        })
                      );
                    }}
                  >
                    {t("change")}
                  </Button>
                )}
              </div>
              <div className="common-pointer bg-light_blue-50 flex flex-col items-center justify-start py-3 px-6 xs:px-3 w-full">
                <div className="flex flex-row items-center justify-between w-full">
                  <div className="flex flex-col gap-1 items-start justify-start">
                    <Text
                      className={`text-base text-black-900 ${headingClass}`}
                      size="txtnunitoMedium16"
                    >
                      {t("yourDetails")}
                    </Text>
                    <Text className={`text-black-900 text-sm ${interClass}`}>
                      {orderData?.userDetails?.first_name}{" "}
                      {orderData?.userDetails?.last_name} |{" "}
                      {CUSTOM.mobileWithCountryCode(
                        CUSTOM.replaceKeyValue(
                          orderData?.userDetails?.mobile_no,
                          "-",
                          " "
                        )
                      )}{" "}
                      {orderData?.userDetails?.email && `| ${orderData?.userDetails?.email}`}
                    </Text>
                  </div>
                  <Img
                    className="h-6 w-6 rtl:rotate-180"
                    src="/images/img_arrowright.svg"
                    alt="arrowright"
                    onClick={(e) => {
                      dispatch(changeTrigger("addpopup"));
                      setYourDetailsOpen(true);
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}

        {/* Login/Signup/Guest Form - Show when account not completed */}
        {!showAccountSummary && (
          <div className="w-full max-w-[650px] bg-white rounded-2xl p-2">
            {isGuestMode ? (
              <>
                <button
                  onClick={() => {
                    setIsGuestMode(false);
                    setErrors({});
                    setAgreeTerms(false);
                  }}
                  className="flex items-center gap-2 mb-4 text-[#6D737E] hover:opacity-80"
                >
                  <Img 
                    src="images/img_arrowright.svg" 
                    alt="back"
                    className="h-5 w-5 rotate-180"
                  />
                  <span className={`text-[16px] font-normal leading-[24px] ${interClass}`}>
                    {t("backToLoginSignup")}
                  </span>
                </button>

                <div className="relative mb-6">
                  <h1
                    className="relative z-10 font-semibold break-words"
                    style={{
                      fontFamily: `${headingFamily}`,
                      fontSize: "clamp(24px, 6vw, 32px)",
                      lineHeight: "1.25",
                      color: "#080808",
                    }}
                  >
                    {t("accountInformation")}
                  </h1>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-4 sm:grid-cols-1">
                  <div>
                    <label
                      className="mb-2 block"
                      style={{
                        color: "#6D737E",
                        fontFamily: `${interFamily}`,
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "16px"
                      }}
                    >
                      {t("firstName")} <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder={t("enterYourFirstName")}
                      className="w-full px-4 py-3 border border-[#E5E7EB] rounded-lg focus:outline-none focus:border-[#7a1236] figma-input"
                      value={guestDetail.first_name}
                      onChange={(e) =>
                        setGuestDetail({ 
                          ...guestDetail, 
                          first_name: CUSTOM.strFormat(e.target.value, "text|max:50")
                        })
                      }
                    />
                    {errors.firstName && (
                      <p className="text-red-500 text-xs mt-1">{errors.firstName}</p>
                    )}
                  </div>

                  <div>
                    <label
                      className="mb-2 block"
                      style={{
                        color: "#6D737E",
                        fontFamily: `${interFamily}`,
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "16px"
                      }}
                    >
                      {t("lastName")} <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder={t("enterYourLastName")}
                      className="w-full px-4 py-3 border border-[#E5E7EB] rounded-lg focus:outline-none focus:border-[#7a1236] figma-input"
                      value={guestDetail.last_name}
                      onChange={(e) =>
                        setGuestDetail({ 
                          ...guestDetail, 
                          last_name: CUSTOM.strFormat(e.target.value, "text|max:50")
                        })
                      }
                    />
                    {errors.lastName && (
                      <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>
                    )}
                  </div>
                </div>

                <label
                  className="mb-2 block sm:text-[12px]"
                  style={{
                    color: "#6D737E",
                    fontFamily: `${interFamily}`,
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "16px"
                  }}
                >
                  {t("mobile")} <span className="text-red-500">*</span>
                </label>

                <div className="flex gap-2 mb-4">
                  <div className={`flex items-center gap-2 px-3 py-3 bg-[#FEFEFE] border border-[#E5E7EB] rounded-lg ${interClass} text-[16px] font-normal leading-[24px] text-[#1A1A1A] whitespace-nowrap`}>
                    <Img
                      src="images/Language1.svg"
                      alt="Saudi Flag"
                      className="rounded-full"
                      style={{
                        width: "22px",
                        height: "22px",
                      }}
                    />
                    <span>+966</span>
                  </div>
                  <input
                    placeholder="XXX XXX XXX"
                    className="flex-1 px-4 py-3 border border-[#E5E7EB] rounded-lg focus:outline-none focus:border-[#7a1236] min-w-0"
                    maxLength={9}
                    value={guestDetail.mobile_no}
                    onChange={(e) =>
                      setGuestDetail({ 
                        ...guestDetail, 
                        mobile_no: CUSTOM.strFormat(e.target.value, "number|max:9")
                      })
                    }
                  />
                </div>
                {errors.mobile && (
                  <p className="text-red-500 text-xs mb-4">{errors.mobile}</p>
                )}

                <div className="mb-4">
                  <label className="flex items-start gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={agreeTerms}
                      onChange={(e) => setAgreeTerms(e.target.checked)}
                      className="mt-1 w-4 h-4 border-2 border-gray-300 rounded focus:ring-2 focus:ring-[#7a1236]"
                    />
                    <span className="text-sm text-gray-700 flex-1">
                      {t("iAgreeToThe")}{" "}
                      <a href="/terms" className="text-[#7a1236] underline">
                        {t("termsAndConditions")}
                      </a>
                    </span>
                  </label>
                  {errors.terms && (
                    <p className="text-red-500 text-xs mt-1">{errors.terms}</p>
                  )}
                </div>

                <Button
                  onClick={saveGuestAndProceed}
                  disabled={disableBtn}
                  className={`
                    w-full bg-[#771237] py-3 rounded-full text-center text-[#FFFFFF] 
                    ${headingClass} text-[16px] font-medium leading-[24px]
                    ${disableBtn ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#B39199]'}
                  `}
                >
                  {t("continue")}
                </Button>
              </>
            ) : (
              <>
                {/* Header */}
                {step === 2 ? (
                  !isLogin ? (
                    <h1
                      className="mb-6 font-semibold"
                      style={{
                        fontFamily: `${headingFamily}`,
                        fontSize: "28px",
                        lineHeight: "36px",
                        color: "#771237",
                      }}
                    >
                      {t("welcome")}, {formData.firstName} 👋
                    </h1>
                  ) : (
                    <div className="relative mb-6">
                      <h1
                        className={`
                          relative z-10 
                          text-[#1A1A1A] ${headingClass} font-medium
                          text-[24px] leading-[32px]
                          sm:text-[20px] sm:leading-[28px]
                        `}
                      >
                        Account Information
                      </h1>
                    </div>
                  )
                ) : (
                  <div className="relative mb-6">
                    <h1
                      className={`
                        relative z-10
                        text-[#1A1A1A] ${headingClass} font-medium
                        text-[24px] leading-[32px]
                        sm:text-[20px] sm:leading-[28px]
                      `}
                    >
                      Account Information
                    </h1>
                  </div>
                )}

                {/* Login/Signup Toggle */}
                {step === 1 && (
                  <div className="flex bg-[#F8F8F8] rounded-full p-1 mb-6">
                    <button
                      onClick={() => {
                        setIsLogin(true);
                        setErrors({});
                        setFormData({
                          mobile: "",
                          firstName: "",
                          lastName: "",
                          otp: ""
                        });
                      }}
                      className={`
                        flex-1 py-2 rounded-full transition ${interClass} text-[16px] sm:text-[12px] font-medium leading-[28px] sm:leading-[16px]
                        ${isLogin ? "bg-[#FFFFFF] shadow text-[#1A1A1A]" : "text-gray-500"}
                      `}
                    >
                      {t("login")}
                    </button>

                    <button
                      onClick={() => {
                        setIsLogin(false);
                        setErrors({});
                        setFormData({
                          mobile: "",
                          firstName: "",
                          lastName: "",
                          otp: ""
                        });
                      }}
                      className={`
                        flex-1 py-2 rounded-full transition ${interClass} text-[16px] sm:text-[12px] font-medium leading-[28px] sm:leading-[16px]
                        ${!isLogin ? "bg-[#FFFFFF] shadow text-black" : "text-gray-500"}
                      `}
                    >
                      {t("signup")}
                    </button>
                  </div>
                )}

                {/* STEP 1 - Mobile and Name */}
                {step === 1 && (
                  <>
                    {!isLogin && (
                      <div className="grid grid-cols-2 gap-4 mb-4 sm:grid-cols-1">
                        <div>
                          <label
                            className="mb-2 block"
                            style={{
                              color: "#6D737E",
                              fontFamily: `${interFamily}`,
                              fontSize: "14px",
                              fontWeight: 500,
                              lineHeight: "16px"
                            }}
                          >
                            {t("firstName")} <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder={t("enterYourFirstName")}
                            className="w-full px-4 py-3 border border-[#E5E7EB] rounded-lg focus:outline-none focus:border-[#7a1236] figma-input"
                            value={formData.firstName}
                            onChange={(e) =>
                              setFormData({ 
                                ...formData, 
                                firstName: CUSTOM.strFormat(e.target.value, "text|max:50")
                              })
                            }
                          />
                          {errors.firstName && (
                            <p className="text-red-500 text-xs mt-1">{errors.firstName}</p>
                          )}
                        </div>

                        <div>
                          <label
                            className="mb-2 block"
                            style={{
                              color: "#6D737E",
                              fontFamily: `${interFamily}`,
                              fontSize: "14px",
                              fontWeight: 500,
                              lineHeight: "16px"
                            }}
                          >
                            {t("lastName")} <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder={t("enterYourLastName")}
                            className="w-full px-4 py-3 border border-[#E5E7EB] rounded-lg focus:outline-none focus:border-[#7a1236] figma-input"
                            value={formData.lastName}
                            onChange={(e) =>
                              setFormData({ 
                                ...formData, 
                                lastName: CUSTOM.strFormat(e.target.value, "text|max:50")
                              })
                            }
                          />
                          {errors.lastName && (
                            <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>
                          )}
                        </div>
                      </div>
                    )}

                    <label
                      className="mb-2 block sm:text-[12px]"
                      style={{
                        color: "#6D737E",
                        fontFamily: `${interFamily}`,
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "16px"
                      }}
                    >
                      {t("mobile")} <span className="text-red-500">*</span>
                    </label>

                    <div className="flex gap-2 mb-2">
                      <div className={`flex items-center gap-2 px-3 py-3 bg-[#FEFEFE] border border-[#E5E7EB] rounded-lg ${interClass} text-[16px] font-normal leading-[24px] text-[#1A1A1A] whitespace-nowrap`}>
                        <Img
                          src="images/Language1.svg"
                          alt="Saudi Flag"
                          className="rounded-full"
                          style={{
                            width: "22px",
                            height: "22px",
                          }}
                        />
                        <span>+966</span>
                      </div>
                      <input
                        placeholder="XXX XXX XXX"
                        className="flex-1 px-4 py-3 border border-[#E5E7EB] rounded-lg focus:outline-none focus:border-[#7a1236] min-w-0"
                        maxLength={9}
                        value={formData.mobile}
                        onChange={(e) =>
                          setFormData({ 
                            ...formData, 
                            mobile: CUSTOM.strFormat(e.target.value, "number|max:9")
                          })
                        }
                      />
                    </div>
                    {errors.mobile && (
                      <p className="text-red-500 text-xs mb-4">{errors.mobile}</p>
                    )}

                    <button
                      onClick={checkUser}
                      disabled={disableBtn}
                      className={`
                        w-full bg-[#7a1236] py-3 rounded-full text-center text-[#FFFFFF] sm:text-[14px] sm:mt-[100%]
                        ${headingClass} text-[16px] font-medium leading-[24px] mt-4
                        ${disableBtn ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'}
                      `}
                    >
                      {isLogin ? t("login") : t("createAccount")}
                    </button>

                    {/* Continue as Guest Button */}
                    <button
                      onClick={() => setIsGuestMode(true)}
                      className={`w-full mt-4 py-3 text-center text-[#0088FF] ${interClass} text-[16px] font-normal leading-[24px] hover:underline`}
                    >
                      {t("continueAsGuest")}
                    </button>
                  </>
                )}

                {/* STEP 2 - OTP Verification */}
                {step === 2 && (
                  <div className="w-full">
                    <div className="mb-6 rounded-lg bg-[#F0FFF4] border border-[#B7E4C7] px-4 py-3">
                      <p className={`text-[14px] ${interClass} text-[#2F855A] break-words`}>
                        {t("otpSentTo")} <span className="font-medium">{CUSTOM.mobileWithCountryCode(formData.mobile)}</span>
                      </p>
                    </div>

                    <h2 className={`mb-4 ${interClass} text-[18px] font-medium leading-[28px] text-[#1A1A1A] justify-center flex sm:text-[16px]`}>
                      {t("enterOtpCode")}
                    </h2>

                    <div className="flex gap-2 sm:gap-3 mb-2 justify-around">
                      {[...Array(4)].map((_, i) => (
                        <input
                          key={i}
                          maxLength={1}
                          type="text"
                          value={formData.otp[i] || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                              const newOtp = formData.otp.split("");
                              newOtp[i] = value;
                              setFormData({ ...formData, otp: newOtp.join("").slice(0, 4) });
                              
                              if (value && i < 3) {
                                const nextInput = e.target.parentElement.children[i + 1];
                                if (nextInput) nextInput.focus();
                              }
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Backspace" && !formData.otp[i] && i > 0) {
                              const prevInput = e.target.parentElement.children[i - 1];
                              if (prevInput) prevInput.focus();
                            }
                          }}
                          className={`w-10 h-10 sm:w-12 sm:h-12 rounded-lg border border-[#E5E7EB] text-center ${interClass} text-[16px] text-[#1A1A1A] focus:outline-none focus:border-[#7a1236]`}
                        />
                      ))}
                    </div>
                    {errors.otp && (
                      <p className="text-red-500 text-xs mb-4 text-center">{errors.otp}</p>
                    )}

                    <p className={`mb-6 ${interClass} text-[16px] font-medium leading-[24px] text-[#727783] sm:text-[14px]`}>
                      {t("didntGetACode")}{" "}
                      <span
                        onClick={sendOtp}
                        className={`
                          ${interClass} text-[16px] font-medium leading-[24px] cursor-pointer sm:text-[14px]
                          ${timer !== 0 ? 'text-[#A2A6AE] opacity-50' : 'text-[#7a1236]'}
                        `}
                      >
                        {t("resendOTP")} {timer > 0 ? `(${timer}s)` : ''}
                      </span>
                    </p>

                    <div className="flex gap-3 sm:mt-[110%]">
                      
                      <button
                        onClick={() => {
                          setStep(1);
                          setFormData({ ...formData, otp: "" });
                          setErrors({});
                        }}
                        className={`flex-1 bg-white border-2 border-[#7a1236] py-3 rounded-full text-[#1A1A1A] text-center ${headingClass} text-[16px] font-medium leading-[24px] hover:bg-[#7a1236] hover:text-white transition
                        sm:text-[14px]`}
                      >
                        {t("changeNumber")}
                      </button>
                      <button
                        onClick={verifyOtp}
                        disabled={disableBtn}
                        className={`
                          flex-1 bg-[#7a1236] py-3 rounded-full text-[#FFFFFF] text-center 
                          ${headingClass} text-[16px] font-medium leading-[24px] sm:text-[14px] sm:leading-[20px] sm:font-small
                          ${disableBtn ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'}
                        `}
                      >
                        {t("verifyOtp")}
                      </button>
                      
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {YourDetailsOpen === true ? (
          <YourDetails
            closepopup={setYourDetailsOpen}
            userDetails={orderData?.userDetails}
            getGuestDetails={getGuestDetails}
            // saveGuest={saveGuest}
            guestDetail={guestDetail}
            setGuestDetail={setGuestDetail}
            isAuth={!!auth?.id}
          />
        ) : null}
      </div>
    </>
  );
};

export default Account;